<script setup lang="ts">
import CoreLink from 'frontcore/views/link/CoreLink.vue'
import i18n from 'frontcore/i18n'
import LogoutCoreButton from 'frontcore/domain/authorization/view/LogoutCoreButton.vue'
import useNotAuthorization from 'frontend/presentation/not-authorization/domain/useNotAuthorization'
import { LoginTypeOptions } from 'frontcore/domain/authorization/model/types'
import { onBeforeMount } from 'vue'
import { useProfileStore } from 'frontcore/store/useProfileStore'

const { t } = i18n.global

const useCase = useNotAuthorization()

const profileStore = useProfileStore()

onBeforeMount(() => {
  useCase.loadAdministrators()
})
</script>

<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-8 tw-relative tw-top-[15%]">
    <p
      data-test="no-access-authorization-header"
      class="tw-text-center headlines--headline-02 tw-text-core-primary-10">{{ useCase.accessMessage }}:
    </p>
    <ul
      class="tw-max-h-[80vh] tw-overflow-y-auto"
      data-test="no-access-admin-list">
      <li
        v-for="item in useCase.administrators"
        :key="item.id"
        data-test="no-access-admin-item"
        class="body--body-01 tw-text-core-primary-10">
        {{ item.name }}
        <CoreLink
          v-if="item.email"
          :linkText="item.email"
          :to="`mailto:${item.email}`"
          :dataTest="`admin-email-${item.id}`"
          isExternal />
      </li>
    </ul>
    <div class="body--body-01 tw-text-core-primary-10">
      {{ t('common.messages.alternative_way_to_contact') }}
      <CoreLink
        :linkText="t('common.messages.support')"
        :to="useCase.mailToSupport"
        dataTest="support-email-link"
        isExternal />
    </div>
    <LogoutCoreButton
      :userLoginType="profileStore.loginType ?? LoginTypeOptions.Django"
      @logoutSuccess="useCase.logout" />
  </div>
</template>
